var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.27454 8.10084C6.9712 8.40462 6.80081 8.81637 6.80078 9.24567V11.5229H9.09223C9.52155 11.5229 9.93397 11.3522 10.238 11.0483L16.9932 4.28945C17.1436 4.13906 17.263 3.96052 17.3444 3.76401C17.4258 3.5675 17.4677 3.35687 17.4677 3.14417C17.4677 2.93146 17.4258 2.72084 17.3444 2.52433C17.263 2.32782 17.1436 2.14927 16.9932 1.99889L16.3257 1.33136C16.1753 1.1808 15.9967 1.06137 15.8001 0.979878C15.6035 0.898389 15.3928 0.856445 15.18 0.856445C14.9672 0.856445 14.7564 0.898389 14.5598 0.979878C14.3632 1.06137 14.1846 1.1808 14.0342 1.33136L7.27454 8.10084Z",
    stroke: "#376AFA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4671 8.85609C17.4671 12.6275 17.4671 14.5127 16.2956 15.6842C15.1241 16.8557 13.2379 16.8557 9.46742 16.8557C5.69603 16.8557 3.81078 16.8557 2.63928 15.6842C1.46777 14.5127 1.46777 12.6266 1.46777 8.85609C1.46777 5.0847 1.46777 3.19945 2.63928 2.02795C3.81078 0.856445 5.69692 0.856445 9.46742 0.856445",
    stroke: "#376AFA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/editIcon.c688bde5d79e4a7b68a3dec68a84e254.svg";
export { ForwardRef as ReactComponent };